// Types
import type { PostMediaType } from '@/types/scheduler/post/media/mediaType';

// Components
import Carousel from '@/components/base/Carousel';
import { MediaItem } from '@/components/composite/MediaOverlay/components/MediaItem';

export function MediaCarousel({
    media,
    activeIndex,
    onPrevious,
    onNext
}: {
    media: PostMediaType[];
    activeIndex: number;
    onPrevious: () => void;
    onNext: () => void;
}) {
    const currentMedia = media[activeIndex];

    return (
        <div className="group relative flex h-full items-center justify-center">
            <MediaItem media={currentMedia} />

            {/* Navigation buttons */}
            {activeIndex > 0 && (
                <Carousel.NavButton
                    onClick={onPrevious}
                    direction="left"
                    position="classic"
                    aria-label="Previous"
                    className="opacity-0 transition-opacity duration-200 group-hover:opacity-100"
                />
            )}
            {activeIndex < media.length - 1 && (
                <Carousel.NavButton
                    onClick={onNext}
                    direction="right"
                    position="classic"
                    aria-label="Next"
                    className="opacity-0 transition-opacity duration-200 group-hover:opacity-100"
                />
            )}
        </div>
    );
}
